import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=9106dcf6&scoped=true"
import script from "./purchase.vue?vue&type=script&lang=js"
export * from "./purchase.vue?vue&type=script&lang=js"
import style0 from "./purchase.vue?vue&type=style&index=0&id=9106dcf6&prod&scoped=true&lang=css"
import style1 from "./purchase.vue?vue&type=style&index=1&id=9106dcf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9106dcf6",
  null
  
)

export default component.exports